import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/images/bg/bg.png';
import _imports_1 from '@/assets/images/icons/tip-full.svg';
import _imports_2 from '@/assets/images/icons/close-whilte.svg';
const _hoisted_1 = {
  class: "position-relative d-flex flex-column",
  style: {
    "min-height": "100vh"
  }
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: _imports_0,
  style: {
    "width": "100%",
    "height": "100%"
  },
  class: "position-absolute"
}, null, -1);
const _hoisted_3 = {
  key: 0,
  class: "herald-top fsi-16 fw-bold"
};
const _hoisted_4 = {
  style: {
    "max-width": "70%"
  },
  class: "flex-center"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {
    "width": "18px",
    "height": "18px"
  },
  class: "mr-2",
  alt: ""
}, null, -1);
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {
    "width": "20px",
    "height": "20px"
  },
  class: "mr-2",
  alt: ""
}, null, -1);
const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = {
  style: {
    "flex": "2 1 0%"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_i_header = _resolveComponent("i-header");
  const _component_router_view = _resolveComponent("router-view");
  const _component_i_footer = _resolveComponent("i-footer");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, false ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createTextVNode(" " + _toDisplayString(_ctx.$t('common.herald')), 1)]), _createElementVNode("div", {
    class: "herald-top-close",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.closeHerald && $options.closeHerald(...args))
  }, _hoisted_7)])) : _createCommentVNode("", true), _createVNode(_component_i_header, {
    ref: "iHeader"
  }, null, 512), _createElementVNode("div", _hoisted_8, [(_openBlock(), _createBlock(_component_router_view, {
    key: _ctx.$route.fullPath
  }))]), _createVNode(_component_i_footer)]);
}